import React from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavLink } from 'reactstrap';

export default function TabNav({ activeTab, setActiveTab, snIntegrationCheck, credentials, isConfigured, hasBugRisk }) {
  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      <Nav tabs className="nav-pills">
        <NavItem
          data-testid={'overview-tab'}
          className={`${
            activeTab === '1' ? 'bg-branding-gray shadow branding-blue' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '1' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('1');
            }}
          >
            {' '}
            Overview
          </NavLink>
        </NavItem>
        <NavItem
          data-testid={'credentials-tab'}
          className={`${activeTab === '2' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'} ${
            credentials ? '' : 'd-none'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '2' ? 'branding-blue' : ''} `}
            onClick={() => {
              toggleTab('2');
            }}
            disabled={!snIntegrationCheck ? true : false}
          >
            Credentials
          </NavLink>
        </NavItem>
        <NavItem
          data-testid={'default-config-tab'}
          className={`${
            activeTab === '3' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '3' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('3');
            }}
            disabled={!snIntegrationCheck ? true : false}
          >
            {' '}
            Settings
          </NavLink>
        </NavItem>
        <NavItem
          data-testid={'filtering-tab'}
          className={`${
            activeTab === '4' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '4' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('4');
            }}
            disabled={!snIntegrationCheck ? true : false}
          >
            {' '}
            Default config
          </NavLink>
        </NavItem>
        {hasBugRisk ? (
          <NavItem
            data-testid={'risk-tab'}
            className={`${
              activeTab === '5' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
            } btn btn-outline-blue mr-3`}
          >
            <NavLink
              className={`${activeTab === '5' ? 'branding-blue' : ''}`}
              onClick={() => {
                toggleTab('5');
              }}
              disabled={!snIntegrationCheck ? true : false}
            >
              {' '}
              Risk score
            </NavLink>
          </NavItem>
        ) : null}
        <NavItem
          className={`${
            activeTab === '6' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
          } btn btn-outline-blue`}
        >
          <NavLink
            className={`${activeTab === '6' ? 'text-white' : 'branding-blue'}`}
            onClick={() => {
              toggleTab('6');
            }}
            disabled={!snIntegrationCheck ? true : false}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
              <path
                fill="currentColor"
                className={`${activeTab === '6' ? 'branding-blue' : 'text-white'}`}
                d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
              />
            </svg>
          </NavLink>
        </NavItem>
      </Nav>
    </>
  );
}

TabNav.propTypes = {
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  snIntegrationCheck: PropTypes.bool,
  credentials: PropTypes.bool,
  setIsLoading: PropTypes.func,
  setServices: PropTypes.func,
  setBugs: PropTypes.func,
  setPriorityStats: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setVendors: PropTypes.func,
  isLoading: PropTypes.bool,
  vendorId: PropTypes.string,
  isConfigured: PropTypes.bool,
  hasBugRisk: PropTypes.bool
};
